import { Field, Checkbox as Checkbox$1 } from '@panwds/react-ui';
import React from 'react';
import { useFormContext, get } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { requiredMessage } from '../../messages.esm.js';

/**
 * Creates a checkbox and lets the user toggle a boolean value.
 */
const Checkbox = (props) => {
    var _a;
    const { label, name, register: registerOptions = {}, disabled, showLabel = true, defaultValue = false, description, requiredAsterisk, ...rest } = props;
    const intl = useIntl();
    const context = useFormContext();
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" && context === null) {
        throw new Error('Attempted to render Checkbox outside of a Form context. Make sure your component is rendered inside <Form>.');
    }
    const { formState, register } = context;
    if (registerOptions.required === true) {
        registerOptions.required = intl.formatMessage(requiredMessage, {
            label
        });
    }
    return (React.createElement(Field, { label: "", control: React.createElement(Checkbox$1, { defaultChecked: defaultValue, ...rest, disabled: disabled, ...register(name, registerOptions) },
            React.createElement("span", { className: showLabel ? '' : 'tw-sr-only' }, label)), error: (_a = get(formState.errors, name)) === null || _a === void 0 ? void 0 : _a.message, description: description, disabled: disabled, connectLabel: false, requiredAsterisk: requiredAsterisk }));
};

export { Checkbox };
//# sourceMappingURL=Checkbox.esm.js.map
